// Mirror of backend telemetry_admin_emails. Keep this list in lockstep with
// backend/app/config.py — the backend gates with 404, this just hides the
// link in the header.
export const ADMIN_EMAILS = new Set<string>(["mehdi.towhidi@gmail.com"]);

export function isAdmin(email: string | null | undefined): boolean {
  if (!email) return false;
  return ADMIN_EMAILS.has(email.toLowerCase());
}
